var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkypeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.03 16.53c-2.66 0-3.85-1.31-3.85-2.29 0-.5.37-.86.88-.86 1.14 0 .85 1.62 2.97 1.62 1.09 0 1.7-.57 1.7-1.18 0-.36-.18-.76-.9-.94l-2.37-.59c-1.91-.48-2.26-1.51-2.26-2.48 0-2.02 1.9-2.78 3.68-2.78 1.62 0 3.58.91 3.58 2.12 0 .52-.46.82-.96.82-1 0-.8-1.35-2.76-1.35-.97 0-1.51.44-1.51 1.07 0 .63.77.81 1.43.99l1.76.39c1.92.43 2.41 1.55 2.41 2.6 0 1.64-1.26 2.86-3.8 2.86zM18 6c2.07 2.04 2.85 4.89 2.36 7.55.41.72.64 1.56.64 2.45a5 5 0 01-5 5c-.89 0-1.73-.23-2.45-.64-2.66.49-5.51-.29-7.55-2.36-2.07-2.04-2.85-4.89-2.36-7.55C3.23 9.73 3 8.89 3 8a5 5 0 015-5c.89 0 1.73.23 2.45.64 2.66-.49 5.51.29 7.55 2.36zM8 5a3 3 0 00-2.2 5.04c-.7 2.24-.17 4.78 1.6 6.56a6.527 6.527 0 006.56 1.6 3 3 0 004.24-4.24c.7-2.24.17-4.78-1.6-6.56a6.527 6.527 0 00-6.56-1.6C9.5 5.3 8.79 5 8 5z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkypeOutline);
export default __webpack_public_path__ + "0f4909779a59e149b1e5b0077ea1a657.svg";
export { ForwardRef as ReactComponent };